export function toggleClassAll(query_string, className) {
  document.querySelectorAll(`${query_string}`).forEach((element) => {
    element.classList.toggle(className);
  });
}

export function toggleClass(element, className) {
  document.getElementById(element).classList.toggle(className);
}
